import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ClientMainBarService } from 'src/app/layout/client/client-main-bar/client-main-bar.service';
import { ApplymentModel } from 'src/app/core/services/client-general-settings/applyment/applyment.model';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@env';
import { GetStepsService } from '@modules/client/registration-steps/pages/registration-steps-page/services/get-steps.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  flipDiv = false;

  public customSettings: any = {};
  public loginForm: FormGroup;
  public loginData: any = {
    login: '',
    birthDate: '',
  };
  public hasAutoLogin = false;
  public env = environment;

  constructor(
    private clientMainBarService: ClientMainBarService,
    private applymentModel: ApplymentModel,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private getStepsService: GetStepsService,
  ) {

    this.getStepsService.data.execute_stage_query = 1;

    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.hasAutoLogin = params.has('login') && params.has('dataNascimento');
      
      this.loginData.login = params.get('login') ?? '';
      this.loginData.birthDate = params.get('dataNascimento') ?? '';
    });

    this.loginForm = new FormGroup({
      login: new FormControl(this.loginData.login, [
        Validators.required
      ]),
      birthDate: new FormControl(this.loginData.password, [
        Validators.required
      ])
    });
  }

  ngOnInit() {
    this.clientMainBarService.setHeaderHideState(true);
    this.customSettings = this.applymentModel.getSettings();

    if (!this.hasAutoLogin){
      this.clientMainBarService.checkLogin().subscribe((loginData: any) => {
        if (loginData.success) {
          this.goToPortalInscrito();  
        }
      });
    } else {
      this.clientMainBarService.clearSession(false, true);
    }
  }

  private goToPortalInscrito() {
    this.router.navigate([this.customSettings.domainParams, 'portal-inscrito'], { queryParamsHandling: 'preserve' });
  }

  ngOnDestroy(): void {
    this.clientMainBarService.setHeaderHideState(false);
  }


  flipIt() {
    this.flipDiv = !this.flipDiv;
  }

  toAccess() {
    console.log('loginData', this.loginData);
  }

}


